import { ApiError } from '../../common/errors.js';
import { maybe } from '../../common/util.js';
import { Icon } from './icons.js';
import { ComponentChildren } from 'preact';

export function ErrorMessage({ error }: { error: Error | string | ComponentChildren }) {
	const [type, message, requestId] = error instanceof ApiError ? [error.error, error.message, error.requestId] : error instanceof Error ? [error.name, error.message, null] : [null, error, null];
	return <div class="error-message">
		<Icon name="warning" />
		<div class="error-message__body">
			<strong>{maybe(type, err => `Error: ${err}`) ?? 'Error'}</strong>
			<div>{message}</div>
			{maybe(requestId, rid => <small>Request ID: {rid}</small>)}
		</div>
	</div>;
}
